export default {
    rangeSelector: {
        buttonSpacing: 5,
        selected: 1
    }
};



// WEBPACK FOOTER //
// ./app/services/charting/presets/full.js